/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-10-20T21:00:00+05:00
Intent: Read a campaign's KYC tier the way the API stores it, so a saved Medium tier comes back as Medium.
*/

export type KycTier = 'light' | 'medium' | 'high';

// The API takes the tier as a word but stores and returns it as a number.
const TIER_BY_NUMBER: KycTier[] = ['light', 'medium', 'high'];

/**
 * The tier of a campaign, from either form the API uses ('medium' or 1).
 * Anything missing or unknown is Light, the create form's default.
 */
export function toKycTier(value: unknown): KycTier {
  const text = String(value ?? '').trim().toLowerCase();
  if (text === 'light' || text === 'medium' || text === 'high') return text;
  if (/^[0-9]+$/.test(text)) return TIER_BY_NUMBER[Number(text)] ?? 'light';
  return 'light';
}
